export default __webpack_public_path__ + "static/media/pr_c_23.0aac978a.jpg";